import { Helmet } from "react-helmet-async";

const Choose = () => {
  return (
    <>
      {/* SEO Metadata */}
      <Helmet>
        <title>Why Choose Us - Best Urologist with 17+ Years of Experience</title>
        <meta name="description" content="Discover why our urology clinic is the top choice, featuring expert surgeons, advanced technology, and personalized patient care." />
        <meta name="keywords" content="best urologist, experienced urologist, advanced urology care, kidney stone specialist, robotic surgery, personalized urology care" />
      </Helmet>

      {/* WHY CHOOSE US Section */}
      <section className="bg-black py-12 px-6 text-blue-500 text-center">
        <h1 className="text-2xl font-bold mb-6">WHY CHOOSE US</h1>
        <div className="grid md:grid-cols-3 gap-6 text-white">
          
          {/* Experienced Surgeon */}
          <div className="border-2 border-gray-300 p-6 rounded-2xl shadow-md hover:bg-teal-600 hover:border-teal-600 transition-all duration-300">
            <div className="text-4xl mb-4" aria-hidden="true">👨‍⚕️</div>
            <h2 className="text-xl font-bold mb-2">Experienced Surgeon</h2>
            <p className="text-sm">Over <strong>17+ years</strong> of expertise in treating complex urology problems.</p>
          </div>

          {/* Advanced Technology */}
          <div className="border-2 border-gray-300 p-6 rounded-2xl shadow-md hover:bg-teal-600 hover:border-teal-600 transition-all duration-300">
            <div className="text-4xl mb-4" aria-hidden="true">🩺</div>
            <h2 className="text-xl font-bold mb-2">Advanced Technology</h2>
            <p className="text-sm">State-of-the-art, <strong>minimally invasive treatments</strong> for faster recovery.</p>
          </div>

          {/* Personalized Care */}
          <div className="border-2 border-gray-300 p-6 rounded-2xl shadow-md hover:bg-teal-600 hover:border-teal-600 transition-all duration-300">
            <div className="text-4xl mb-4" aria-hidden="true">🏥</div>
            <h2 className="text-xl font-bold mb-2">Personalized Care</h2>
            <p className="text-sm">Tailored treatment plans ensuring the <strong>best outcomes</strong> for every patient.</p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Choose;
